import { createContext, ReactNode, useState } from "react";

type FiltersContextType = {
    categories: string[];
    setCategories: (categories: string[]) => void;
    gridFilter: GridType[];
    setGridFilter: (grids: GridType[]) => void;
    limits: number[];
    setLimits: (limit: number[]) => void;
    vendorCart: VendorCart ;
    setVendorCart: (vendorCart: VendorCart) => void;
    searching: boolean;
    setSearching: (src: boolean) => void;
}

type FiltersContextProviderProps = {
    children: ReactNode;
}

type VariationType = {
    name: string;
    checked: boolean;
}

export type GridType = {
    id: number;
    name: string;
    variations: VariationType[];
}

export type VendorCart = {
    initAt: string 
    finishAt: string 
    order: string
    cpfCustomer: string 
    status: string[] 

}

export const FiltersContext = createContext({} as FiltersContextType);

export function FiltersContextProvider(props: FiltersContextProviderProps) {

    const [categories, setCategories] = useState<string[]>([]);
    const [gridFilter, setGridFilter] = useState<GridType[]>([]);
    const [limits, setLimits] = useState<number[]>([]);
    const [vendorCart, setVendorCart] = useState<VendorCart>({
        initAt: ``,
        finishAt: ``,
        order: '',
        cpfCustomer: '',
        status: []
    });
    const [searching, setSearching] = useState(false);

    return (
        <FiltersContext.Provider value={{ categories, setCategories, gridFilter, setGridFilter, limits, setLimits, vendorCart, setVendorCart, searching, setSearching }}>
            {props.children}
        </FiltersContext.Provider>
    );
}